import { render } from "./LeaveOTPConfig.vue?vue&type=template&id=5f8e7162&scoped=true&ts=true"
import script from "./LeaveOTPConfig.vue?vue&type=script&lang=ts"
export * from "./LeaveOTPConfig.vue?vue&type=script&lang=ts"

import "./LeaveOTPConfig.vue?vue&type=style&index=0&id=5f8e7162&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8e7162"]])

export default __exports__